import { CanMatchFn } from '@angular/router';
import { UserService } from '../../services/user.service';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserOptions } from '../../types/user-options';

export const orderGuard: CanMatchFn = async () => {
	const userService: UserService = inject(UserService);
	const user = await firstValueFrom(userService.user);

	if (user) {
		return !!user && userService.userHasOption(user, UserOptions.ORDER_PORTAL);
	} else {
		return false;
	}
};
